import * as React from "react";
import { AuthGuard } from "./AuthGuard";
import { useAddInStore, useTokenStore } from "../../hooks";
import { OfficeItemProvider } from "../../providers";
import { useEffect } from "react";
import Main from "./Views/Main";
import { logger } from "../../utils";

const App: React.FC = () => {
  // resets the state when the component is mounted
  const resetAddInState = useAddInStore((state) => state.resetState);

  useEffect(() => {
    // reset the add-in state when the component is mounted
    // this is to ensure that the state is reset when the add-in is loaded
    // in a new context (e.g. when the user switches between different Office apps)
    resetAddInState();
  }, []);

  return (
    <AuthGuard>
      <OfficeItemProvider>
        <Main />
      </OfficeItemProvider>
    </AuthGuard>
  );
};

export default App;
